import {
  ApplePodcastsIcon,
  BlueskyIcon,
  DiscordIcon,
  FacebookIcon,
  InstagramIcon,
  KickIcon,
  KofiIcon,
  LinkedInIcon,
  LiveSpaceIcon,
  PatreonIcon,
  PinterestIcon,
  RedditIcon,
  SnapchatIcon,
  SoundCloudIcon,
  SpotifyIcon,
  ThreadsIcon,
  ThroneIcon,
  TikTokIcon,
  TwitchIcon,
  TwitterIcon,
  XIcon,
  YoutubeIcon,
} from '@fourthwall/icons'

import { routing } from '../../../utils/routing'

export const YOUTUBE_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(youtube.com\/)(channel\/)(?<handle>[\w._-]+)(\S+)?$/
export const YOUTUBE_HANDLE_REGEX = /^([\w._-]+)$/

export const getYoutubeHandle = (url: string) => {
  return url.match(YOUTUBE_URL_REGEX)?.groups?.handle
}

export const INSTAGRAM_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(instagram\.com\/)(@?)(?<handle>[\w._-]+)(\S+)?$/i
export const INSTAGRAM_HANDLE_REGEX = /^([\w._-]+)$/

export const getInstagramHandle = (url: string) => {
  return url.match(INSTAGRAM_URL_REGEX)?.groups?.handle
}

export const FACEBOOK_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(\w\w-\w\w\.)?(facebook\.com\/)(?<handle>[\w._-]+)(\S+)?$/i
export const FACEBOOK_HANDLE_REGEX = /^([\w._-]+)$/

export const getFacebookHandle = (url: string) => {
  return url.match(FACEBOOK_URL_REGEX)?.groups?.handle
}

export const TWITTER_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/(@)?(?<handle>[\w._-]+)(\S+)?$/i
export const TWITTER_HANDLE_REGEX = /^(@)?([\w._-]+)$/

export const getTwitterHandle = (url: string) => {
  return url.match(TWITTER_URL_REGEX)?.groups?.handle
}

export const TIKTOK_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(tiktok\.com)\/(@)?(?<handle>[\w._-]+)(\S+)?$/i
export const TIKTOK_HANDLE_REGEX = /^(@)?(?<handle>[\w._-]+)$/

export const getTiktokHandle = (url: string) => {
  const urlHandle = url.match(TIKTOK_URL_REGEX)?.groups?.handle
  const textHandle = url.match(TIKTOK_HANDLE_REGEX)?.groups?.handle
  const handle = urlHandle || textHandle

  const parseHandle = (handle: string) => {
    return handle.startsWith('@') ? handle : `@${handle}`
  }

  return handle ? parseHandle(handle) : undefined
}

export const SNAPCHAT_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(snapchat\.com)(\/add\/)(?<handle>[\w._-]+)(\S+)?$/i
export const SNAPCHAT_HANDLE_REGEX = /^([\w._-]+)$/

export const getSnapchatHandle = (url: string) => {
  return url.match(SNAPCHAT_URL_REGEX)?.groups?.handle
}

export const DISCORD_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(discord.(gg|io|me|li|com)|(discordapp\.com\/invite))\/(invite\/)?(?<handle>[\w._-]+)(\S+)?$/i
export const DISCORD_HANDLE_REGEX = /^([\w._-]+)$/

export const getDiscordHandle = (url: string) => {
  return url.match(DISCORD_URL_REGEX)?.groups?.handle
}

export const TWITCH_URL_REGEX = /^(https?:\/\/)?(www\.)?(twitch\.tv)\/(?<handle>[\w._-]+)(\S+)?$/i
export const TWITCH_HANDLE_REGEX = /^([\w._-]+)$/

export const getTwitchHandle = (url: string) => {
  return url.match(TWITCH_URL_REGEX)?.groups?.handle
}

export const SPOTIFY_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(open\.spotify\.com)\/user\/(?<handle>[\w._-]+)(\S+)?$/i
export const SPOTIFY_HANDLE_REGEX = /^([\w._-]+)$/

export const getSpotifyHandle = (url: string) => {
  return url.match(SPOTIFY_URL_REGEX)?.groups?.handle
}

export const REDDIT_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(reddit\.com)\/r\/(?<handle>[\w._-]+)(\S+)?$/i
export const REDDIT_HANDLE_REGEX = /^([\w._-]+)$/

export const getRedditHandle = (url: string) => {
  return url.match(REDDIT_URL_REGEX)?.groups?.handle
}

export const KICK_URL_REGEX = /^(https?:\/\/)?(www\.)?(kick\.com)\/(?<handle>[\w._-]+)(\S+)?$/i

export const getKickHandle = (url: string) => {
  return url.match(KICK_URL_REGEX)?.groups?.handle
}

export const KOFI_URL_REGEX = /^(https?:\/\/)?(www\.)?(ko-fi\.com)\/(?<handle>[\w._-]+)(\S+)?$/i

export const getKofiHandle = (url: string) => {
  return url.match(KOFI_URL_REGEX)?.groups?.handle
}

export const PATREON_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(patreon\.com)\/(?<handle>[\w._\/-]+)(\?.*)?$/i

export const getPatreonHandle = (url: string) => {
  const match = url.match(PATREON_URL_REGEX)
  if (!match?.groups?.handle) return undefined

  return match.groups.handle.replace(/\/$/, '')
}

export const THREADS_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(threads\.net)\/(@)?(?<handle>[\w._-]+)(\S+)?$/i
export const THREADS_HANDLE_REGEX = /^(@)?(?<handle>[\w._-]+)$/

export const getThreadsHandle = (url: string) => {
  const urlHandle = url.match(THREADS_URL_REGEX)?.groups?.handle
  const textHandle = url.match(THREADS_HANDLE_REGEX)?.groups?.handle
  const handle = urlHandle || textHandle

  const parseHandle = (handle: string) => {
    return handle.startsWith('@') ? handle : `@${handle}`
  }

  return handle ? parseHandle(handle) : undefined
}

export const LIVESPACE_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(live\.space)\/(?<handle>[\w._-]+)(\S+)?$/i

export const getLiveSpaceHandle = (url: string) => {
  return url.match(LIVESPACE_URL_REGEX)?.groups?.handle
}

export const PINTEREST_URL_REGEX =
  /^(https?:\/\/)?(www\.)?([a-z]{2}\.)?(pinterest\.com)\/(?<handle>[\w._-]+)(\S+)?$/i

export const getPinterestHandle = (url: string) => {
  return url.match(PINTEREST_URL_REGEX)?.groups?.handle
}

export const SOUNDCLOUD_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(soundcloud\.com)\/(?<handle>[\w._-]+)(\S+)?$/

export const getSoundCloudHandle = (url: string) => {
  return url.match(SOUNDCLOUD_URL_REGEX)?.groups?.handle
}

export const THRONE_URL_REGEX = /^(https?:\/\/)?(www\.)?(throne\.com)\/(?<handle>[\w._-]+)(\S+)?$/i

export const getThroneHandle = (url: string) => {
  return url.match(THRONE_URL_REGEX)?.groups?.handle
}

export const BLUESKY_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(bsky\.app)(\/profile\/)(?<handle>[\w._-]+)(\S+)?$/i

export const getBlueskyHandle = (url: string) => {
  return url.match(BLUESKY_URL_REGEX)?.groups?.handle
}

export const LINKEDIN_URL_REGEX =
  /^(https?:\/\/)?(www\.)?([a-z]{2}\.)?linkedin\.com\/(?<handle>(in|company)\/[\w._-]+)(\S+)?$/i
export const LINKEDIN_HANDLE_REGEX = /^((in|company)\/[\w._-]+)$/

export const getLinkedInHandle = (url: string) => {
  return url.match(LINKEDIN_URL_REGEX)?.groups?.handle
}

const iconsMap: any = {
  social_youtube: YoutubeIcon,
  social_instagram: InstagramIcon,
  social_facebook: FacebookIcon,
  social_twitter: TwitterIcon,
  social_twitch: TwitchIcon,
  social_discord: DiscordIcon,
  social_snapchat: SnapchatIcon,
  social_tiktok: TikTokIcon,
  social_spotify: SpotifyIcon,
  social_reddit: RedditIcon,
  social_apple_podcasts: ApplePodcastsIcon,
  social_kick: KickIcon,
  social_kofi: KofiIcon,
  social_linkedin: LinkedInIcon,
  social_patreon: PatreonIcon,
  social_threads: ThreadsIcon,
  social_livespace: LiveSpaceIcon,
  social_pinterest: PinterestIcon,
  social_soundcloud: SoundCloudIcon,
  social_throne: ThroneIcon,
  social_x: XIcon,
  social_bluesky: BlueskyIcon,
}

export const getSocialIcon = (inputKey: string) => iconsMap[inputKey]

const socialHandlersMap: any = {
  social_youtube: getYoutubeHandle,
  social_instagram: getInstagramHandle,
  social_facebook: getFacebookHandle,
  social_twitter: getTwitterHandle,
  social_tiktok: getTiktokHandle,
  social_snapchat: getSnapchatHandle,
  social_discord: getDiscordHandle,
  social_twitch: getTwitchHandle,
  social_spotify: getSpotifyHandle,
  social_reddit: getRedditHandle,
  social_kick: getKickHandle,
  social_kofi: getKofiHandle,
  social_linkedin: getLinkedInHandle,
  social_patreon: getPatreonHandle,
  social_threads: getThreadsHandle,
  social_livespace: getLiveSpaceHandle,
  social_pinterest: getPinterestHandle,
  social_soundcloud: getSoundCloudHandle,
  social_throne: getThroneHandle,
  social_x: getTwitterHandle,
  social_bluesky: getBlueskyHandle,
}

export const getSocialHandler = (inputKey: string) => socialHandlersMap[inputKey]

const labelsMap: Record<string, string> = {
  youtube: 'YouTube',
  instagram: 'Instagram',
  facebook: 'Facebook',
  twitter: 'Twitter',
  twitch: 'Twitch',
  discord: 'Discord',
  snapchat: 'Snapchat',
  tiktok: 'TikTok',
  spotify: 'Spotify',
  reddit: 'Reddit',
  apple_podcasts: 'Apple Podcasts',
  kick: 'Kick',
  kofi: 'Ko-fi',
  linkedin: 'LinkedIn',
  patreon: 'Patreon',
  threads: 'Threads',
  livespace: 'LiveSpace',
  pinterest: 'Pinterest',
  soundcloud: 'SoundCloud',
  throne: 'Throne',
  x: 'X',
  bluesky: 'Bluesky',
}

export const getSocialLabel = (inputKey: string) => labelsMap[inputKey] || inputKey

const integrationUrlsMap: any = {
  instagram: routing.apps.instagramFeed,
  twitch: routing.apps.twitch,
  discord: routing.apps.discord,
  tiktok: routing.apps.tiktok,
}

export const getSocialIntegrationUrl = (inputKey: string) => integrationUrlsMap[inputKey]
